<template>
    <div class="rating-title">
        <b-form-select class="apprentice-primary-select with-border rating-property-select"
                       :value="selectedValue"
                       :options="selectOptions"
                       v-model="selectedValue"
                       :value-field="valueField"
                       :text-field="textField"
                       @input="inputUpdate">
        </b-form-select>
    </div>
</template>

<script>
    export default {
        name: "design-2021-group-show-rating-select-component",
        props: {
            selectOptionsIn: Array,
            valueField: String,
            textField: String,
            value: Number,
        },

        data() {
            return {
                selectOptions: [
                    {
                        value: null,
                        [this.textField]: this.$t('group.show.choose_option'),
                    },
                    ...this.selectOptionsIn,
                ],
                selectedValue: this.value,
            }
        },

        methods: {
            inputUpdate() {
                this.$emit('input', this.selectedValue);
            }
        }
    }
</script>

<style scoped lang="scss">
    .rating-property-select {
        margin-bottom: 0;
    }
</style>
